import DescriptionIcon from '@mui/icons-material/Description';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { AuthenticatedTemplate } from '@azure/msal-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../../app/hooks';
import { useGetMyProfileQuery } from '../../../../../services/ProfileService';
import { isMedicalRecordsEnabled } from '../../../../../utils/authConfig';
import { hasMedicalRecordsAccess } from '../../../../profile/utils/profileUtils';

const MEDICAL_RECORDS_REQUEST_PATH = '/medical-records/request';
const MEDICAL_RECORDS_REQUESTS_PATH = '/medical-records/requests';

function EnabledMedicalRecordsMenu() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const selectedCenter = useAppSelector((state) => state.center.selectedCenter);
  const { data: profile } = useGetMyProfileQuery();
  const company = profile?.organization || '';

  const navigateTo = (path: string) => {
    const params = new URLSearchParams();
    if (company) params.append('company', company);
    if (selectedCenter) params.append('center', selectedCenter);
    navigate(`${path}?${params.toString()}`);
  };

  if (!hasMedicalRecordsAccess(profile)) return null;

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        <List component="nav" aria-label="Records Request" sx={{ border: 'black solid 1px' }}>
          <ListItemButton onClick={() => setOpen(!open)} aria-expanded={open}>
            <ListItemText primary="Records Request" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <ListItemButton onClick={() => navigateTo(MEDICAL_RECORDS_REQUEST_PATH)} data-testid="medical-records-request-menu-button">
              <ListItemIcon>
                <DescriptionIcon sx={{ color: 'white' }} />
              </ListItemIcon>
              <ListItemText primary="Request Documents" />
            </ListItemButton>
            <ListItemButton onClick={() => navigateTo(MEDICAL_RECORDS_REQUESTS_PATH)} data-testid="medical-records-requests-menu-button">
              <ListItemIcon>
                <DescriptionIcon sx={{ color: 'white' }} />
              </ListItemIcon>
              <ListItemText primary="My Requests" />
            </ListItemButton>
          </Collapse>
        </List>
      </AuthenticatedTemplate>
    </React.Fragment>
  );
}

/** Feature exposure is build-gated; backend authorization remains authoritative when enabled. */
function MedicalRecordsMenu() {
  return isMedicalRecordsEnabled() ? <EnabledMedicalRecordsMenu /> : null;
}

export { MedicalRecordsMenu };
